import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MoreDetailsDriver from 'pages/vendor/driverVendor/MoreDetailsDriver';
import CommonTable from 'components/commonTable/CommonTable';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';
import Loader from 'components/loader/Loader';

function TabSubVendor({
  onTabChange,
  tableData,
  onClickTable,
  value,
  onClickMoreIcon,
  handleChangePage,
  handleChangeRowsPerPage,
  page,
  rowsPerPage,
  onFilterChange,
  onRestFilter,
  filterdata,
  subVendorMoreDetails,
  subVendorLocation,
  onSearch,
  defaultStatus,
  chooseYourServiceData,
  loaderDriver,
  loaderVehicle,
  loaderSubVendorMoreData,
}) {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md')); // mobile + tablet view

  const handleChange = (event, newValue) => {
    onTabChange(newValue);
  };

  const onClickTableVendor = (val) => {
    onClickTable(val);
  };

  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={value}>
            {/* Tabs Row */}
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={12} md={6}>
                <TabList
                  className="minHeight32"
                  onChange={handleChange}
                  aria-label="sub-vendor tabs"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' },
                  }}
                >
                  <Tab label="Driver" value="1" className="tabStyle" />
                  <Tab label="Vehicle" value="2" className="tabStyle" />
                  <Tab label="More Details" value="3" className="tabStyle" />
                </TabList>
              </Grid>

              {/* Desktop: Search + Filter beside tabs */}
              {!isMobileOrTablet && value !== '3' && (
                <Grid
                  item
                  container
                  md={6}
                  spacing={1}
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Grid item>
                    <SearchBar onSearch={onSearch} />
                  </Grid>
                  <Grid item>
                    <CommonFilter
                      defaultStatus={defaultStatus}
                      filterdata={filterdata}
                      onFilterChange={onFilterChange}
                      onRestFilter={onRestFilter}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>

            {/* Mobile + Tablet: Search + Filter below Tabs */}
            {isMobileOrTablet && value !== '3' && (
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                alignItems="center"
                sx={{ mt: 1 }}
              >
                <Grid item xs={8}>
                  <SearchBar onSearch={onSearch} />
                </Grid>
                <Grid item xs={4}>
                  <CommonFilter
                    defaultStatus={defaultStatus}
                    filterdata={filterdata}
                    onFilterChange={onFilterChange}
                    onRestFilter={onRestFilter}
                  />
                </Grid>
              </Grid>
            )}

            {/* Tab Panels */}
            <TabPanel value="1" sx={{ width: '100%' }} className="tabPanelStyle">
              {loaderDriver ? (
                <Loader />
              ) : (
                <CommonTable
                  data={tableData}
                  onClickTableVendor={onClickTableVendor}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onClickMoreIcon={onClickMoreIcon}
                  tabName="driver"
                  isClickable
                />
              )}
            </TabPanel>

            <TabPanel value="2" className="tabPanelStyle">
              {loaderVehicle ? (
                <Loader />
              ) : (
                <CommonTable
                  data={tableData}
                  onClickTableVendor={onClickTableVendor}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onClickMoreIcon={onClickMoreIcon}
                  tabName="vehicle"
                  isClickable
                />
              )}
            </TabPanel>

            <TabPanel value="3" className="tabPanelStyle">
              {loaderSubVendorMoreData ? (
                <Loader />
              ) : (
                <MoreDetailsDriver
                  subVendorMoreDetails={subVendorMoreDetails}
                  subVendorLocation={subVendorLocation}
                  chooseYourServiceData={chooseYourServiceData}
                />
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default TabSubVendor;
